// Libraries
import {defineStore} from 'pinia';
import {BaseDictionaryStore} from '../baseDictionaryStore';
// Module
import {ModuleDefaultAccount} from '../moduleConst';
// Apis
import defaultAccountAPI from '@/apis/di/defaultAccountAPI';

// Use
const defaultAccountStore = new BaseDictionaryStore(defaultAccountAPI);
// Export
export const useDefaultAccountStore = defineStore(ModuleDefaultAccount, {
  state: () => ({
    ...defaultAccountStore.state,
    _config: {key: 'ref_type', name: 'ref_type_name', table: 'ref_type', moduleName: 'Tài khoản ngầm định'},
    moduleName: 'defaultAccount',
  }),
  actions: {...defaultAccountStore.action},
  getters: {
    ...defaultAccountStore.getters,
  },
});
